export default __webpack_public_path__ + "static/media/check.10e8365f.svg";